import { aStar, uniformCost } from "./algo";
import {
  chebyshevDistance,
  euclideanDistance,
  manhattanDistance,
  octileDistance,
  getNeighbourNodes,
  getNeighbourNodesDiag,
} from "./general";


export const animationIntervalOptions = [
  { value: 2, label: "Very fast" },
  { value: 10, label: "Fast" },
  { value: 50, label: "Medium" },
  { value: 100, label: "Slow" },
  { value: 1000, label: "Very slow" },
];

export const algorithmTypeOptions = [
  { value: uniformCost, label: "Dijkstra" },
  { value: aStar, label: "A*" },
];

export const heuristicOptions = [
  { value: manhattanDistance, label: "Manhattan" },
  { value: euclideanDistance, label: "Euclidean" },
  { value: chebyshevDistance, label: "Chebyshev" },
  { value: octileDistance, label: "Octile" },
];

export const movementStyleOptions = [
  { value: getNeighbourNodesDiag, label: "Diagonal" },
  { value: getNeighbourNodes, label: "Orthogonal" },
];
